module.exports = __webpack_public_path__ + "fa-solid-900.svg?5eef26d6096e6688a0f7b9e0ee960e1b";